// extracted by mini-css-extract-plugin
export default {"articleItemContainer":"index_snow_articleItemContainer__YpnH4","contentWrapper":"index_snow_contentWrapper__Y-PhJ","wrapper":"index_snow_wrapper__xA016"};